<mat-error
  *ngIf="control.hasError('required') && control.touched"
  class="text text-danger"
  style="margin-top: -1rem"
>
  * {{ 'Campo obrigatório' | translate }}.
</mat-error>
<mat-error
  *ngIf="
    minLength &&
    control.value.length > 0 &&
    control.value.length < minLength &&
    control.touched
  "
  class="text text-danger"
  style="margin-top: -1rem"
>
  * {{ 'Mínimo de' | translate }} {{ minLength }}
  {{ 'caracteres' | translate }}.
</mat-error>
<mat-error
  *ngIf="control.hasError('pattern') && control.touched"
  class="text text-danger"
  style="margin-top: -1rem"
>
  * {{ 'Por favor, informe um' | translate }} {{ title | translate }}
  {{ 'válido' | translate }}.
</mat-error>
<mat-error
  *ngIf="
    control.touched &&
    minDate &&
    control.value !== '' &&
    control.value < minDate
  "
  class="text text-danger"
  style="margin-top: -1rem"
>
  * {{ 'Por favor, informe uma data maior ou igual a' | translate }}
  {{ minDate | date: 'dd/MM/yyyy' }}
</mat-error>
<mat-error
  *ngIf="
    control.touched &&
    maxDate &&
    control.value !== '' &&
    control.value > maxDate
  "
  class="text text-danger"
  style="margin-top: -1rem"
>
  * {{ 'Por favor, informe uma data menor ou igual a' | translate }}
  {{ maxDate | date: 'dd/MM/yyyy' }}
</mat-error>
<mat-error
  *ngIf="control.hasError('incorrect') && control.touched"
  class="text text-danger"
  style="margin-top: -1rem"
>
  * {{ control.errors?.['message'] | translate }}
</mat-error>
<mat-error
  *ngIf="control.hasError('invalidDate') && control.touched"
  class="text text-danger"
  style="margin-top: -1rem"
>
  * {{ 'Data inválida' | translate }}.
</mat-error>
